module.exports = __webpack_public_path__ + "img/mobileIcon.5ca27186.svg";